import {
  phosphatidylserine,
  bcomplex,
  taurine,
  ltheanine,
  melatonin,
  vitamind,
  gaba,
  caffeine,
  passionflower,
  echinaceaAngustipholia,
  andrographis,
  echinaceaPurpurea,
  berberis,
  astragalus,
  cticoline,
  lutein,
  zeaxanthin,
  choline,
  folate,
  inositol,
  niacin,
  paraAminobenzoic,
  riboflavin,
  thiamin,
  vitaminB6,
  vitaminB12,
  ascorbicAcid,
  pantothenic,
  biotin,
  molybdenum,
  AcetyleCystine,
  selenium,
  CoQ10,
  redYeastExtract,
  VEPfolate,
  VEPvitaminB6,
  VEPvitaminB12,
  berberisAristata,
  aztecMarigold,
  Selenium,
  bitartrate,
  dunaliella,
  tocotrienol,
  vitaminA,
  vitaminE,
  vitaminD,
  vitaminK2,
  calcium,
  catalase,
  bioflavonoid,
  greenTea,
  hesperidin,
  magnesium,
  quercetin,
  antioxidantResveratrol,
  rutin,
  sod,
  vitaminC,
} from '../../../src/images';
import { ProductsCategory } from '../../../config';

import { curcumin, icariin, omega, resveratrol } from '../../../src/images';

const reliefFactorIngredients = [
  {
    name: 'Resveratrol',
    image: resveratrol,
    qus: 'How Does it Support Pain Relief?',
    content:
      'A potent free-radical neutralizer that offers broad-spectrum support for the body’s normal and natural vascular response and supports blood vessel health. Promotes a healthy response to biological stress.',
    volume: '70 mg',
  },
  {
    name: 'Omega-3',
    image: omega,
    qus: 'How Does it Support Pain Relief?',
    content:
      'Highly concentrated EPA/DHA supports healthy tissue maintenance and the normal expression of genes involved in the body’s balanced immune response. Promotes the body’s natural healing abilities.',
    volume: '1.4 g',
  },
  {
    name: 'Turmeric',
    image: curcumin,
    qus: 'How Does it Support Pain Relief?',
    content:
      'Provides Curcumin extract for consistent potency in every serving. Promotes the body’s natural and healthy response to overexertion that can cause minor, but temporary discomfort. Supports the balanced activities of multiple enzyme systems.',
    volume: '667 mg',
  },
  {
    name: 'Icariin',
    image: icariin,
    qus: 'How Does it Support Pain Relief?',
    content:
      'Helps maintain optimal production of nitric oxide to support blood flow and promote tissue health. May support the natural response to everyday wear and tear by affecting the genetic expression of key enzymes.',
    volume: '200 mg',
  },
];
const thinkFactorIngredients = [
  {
    name: 'Citicoline',
    image: cticoline,
    qus: '',
    content: `<strong>Memory and Cognitive:</strong> Citicoline supports brain cell membrane health and may improve memory, attention, and cognition.* It's also studied for memory loss in dementia and brain injury.<br/><br/>
    <strong>Other Benefits:</strong> May boost neurotransmitter levels, protect neurons, support mood, and has been researched for stroke recovery.*`,
    volume: '500 mg',
  },
  // {
  //   name: 'Andrographis',
  //   image: omega,
  //   qus: '',
  //   content:
  //     'Known in herbal traditions for bolstering immune defenses, especially during seasonal challenges.',
  //   volume: '100 mg',
  // },
  {
    name: 'Lutein',
    image: lutein,
    qus: '',
    content: `<strong>Memory:</strong> Lutein may help protect against age-related cognitive decline and support memory as we age.*
</br></br>
    <strong>Other Benefits:</strong> Supports eye health by lowering the risk of macular degeneration and cataracts. Its antioxidant properties help reduce oxidative stress.*`,
    volume: '10 mg',
  },
  {
    name: 'Zeaxanthin',
    image: zeaxanthin,
    qus: '',
    content: `<strong>Memory:</strong> Zeaxanthin may support cognitive function and help maintain memory with age.*</br></br>
      <strong>Other Benefits:</strong> Works with lutein to protect the retina from blue light and age-related eye issues. Also offers antioxidant support for overall health.*wellness.*`,
    volume: '2mg',
  },
];
const zenIngredients = [
  {
    name: 'Phosphatidylserine',
    image: phosphatidylserine,
    qus: '',
    content:
      'Is produced by the body to help manage cortisol in response to stress. It also supports healthy brain function, memory, and mental focus.',
    volume: '50 mg',
  },
  {
    name: 'Passionflower',
    image: passionflower,
    qus: '',
    content:
      'Is a traditional medicinal herb used to support healthy nervous system function and eases normal mild tension.',
    volume: '87.5 mg',
  },
];
const goFactorIngredients = [
  {
    name: 'B-Complex',
    image: bcomplex,
    qus: '',
    content:
      'Helps your body absorb and process nutrients from the food you eat, allowing your body to be more efficient in burning its caloric intake and using energy. ',
    volume: '50 mg',
  },
  {
    name: 'Caffeine',
    image: caffeine,
    qus: '',
    content:
      'Two capsules of Go Factor contains the same amount of caffeine as half a cup of coffee—enough to give you a boost, without the jitters or keeping you up at night.',
    volume: '50 mg',
  },
  {
    name: 'Taurine',
    image: taurine,
    qus: '',
    content:
      'Supports improved physical performance, muscular efficiency, and improved recovery after exertion.',
    volume: '750 mg',
  },
];
const zFactorIngredients = [
  {
    name: 'GABA',
    image: gaba,
    qus: '',
    content:
      'Gamma-aminobutyric acid (GABA) makes you drowsy and relaxed and improves your mood. GABA helps you fall asleep quickly, and then wake up ready for the day.',
    volume: '600 mg',
  },
  {
    name: 'Melatonin ',
    image: melatonin,
    qus: '',
    content:
      'A hormone naturally produced by the body to regulate sleep. When your natural sleep cycle is disrupted, taking melatonin has been recommended to help restore your sleep.',
    volume: '2 mg',
  },
  {
    name: 'L-Theanine',
    image: ltheanine,
    qus: '',
    content:
      'This active ingredient in green tea helps you relax, fall asleep quickly, and stay asleep, then wears off with no lingering effects.',
    volume: '500 mg',
  },
  {
    name: 'Vitamin D3 ',
    image: vitamind,
    qus: '',
    content:
      'Our bodies naturally produce Vitamin D3 with time in the sun, but we often don’t spend enough time outside. Many studies have shown that D3 supports healthy sleep.',
    volume: '20 mcg',
  },
];
const antiOxidantIngredients = [
  {
    name: 'Vitamin C',
    image: vitaminC,
    qus: '',
    content:
      'Known for supporting collagen formation, immune health, and antioxidant defense.',
    volume: '411 mg (457% DV)',
  },
  {
    name: 'Calcium',
    image: calcium,
    qus: '',
    content: 'Assists in maintaining bone health.',
    volume: '40 mg (3% DV)',
  },
  {
    name: 'Magnesium',
    image: magnesium,
    qus: '',
    content:
      'An essential mineral for energy production and overall well-being.',
    volume: '15 mg (4% DV)',
  },
  {
    name: 'Quercetin',
    image: quercetin,
    qus: '',
    content:
      'A bioflavonoid known for its antioxidant and anti-inflammatory properties.',
    volume: '89 mg',
  },
  {
    name: 'Citrus Bioflavonoids',
    image: bioflavonoid,
    qus: '',
    content:
      'Helps enhance the effects of Vitamin C and support vascular health.',
    volume: '21 mg',
  },
  {
    name: 'Rutin',
    image: rutin,
    qus: '',
    content: 'Supports capillary strength and additional antioxidant benefits.',
    volume: '79 mg',
  },
  {
    name: 'Hesperidin',
    image: hesperidin,
    qus: '',
    content:
      'A potent flavonoid that may aid circulation and antioxidant defense.',
    volume: '46 mg',
  },
  {
    name: 'Green Tea Leaf',
    image: greenTea,
    qus: '',
    content:
      'Traditionally revered for supporting metabolism and cellular health.',
    volume: '25 mg',
  },
  {
    name: 'Resveratrol',
    image: antioxidantResveratrol,
    qus: '',
    content: 'Associated with healthy aging and cardiovascular support.',
    volume: '1 mg',
  },
  {
    name: 'Superoxide Dismutase (SOD)',
    image: sod,
    qus: '',
    content: 'An important enzyme for neutralizing superoxide radicals.',
    volume: '50 mcg',
  },
  {
    name: 'Catalase',
    image: catalase,
    qus: '',
    content:
      'Another crucial enzyme that helps break down harmful hydrogen peroxide.',
    volume: '2 mg',
  },
];
const berberineIngredients = [
  {
    name: 'Berberine',
    image: berberisAristata,
    qus: '',
    content:
      'Traditionally used to support healthy blood sugar metabolism, digestion, and cardiovascular function. The high concentration ensures you receive a potent, consistent dose every time.',
    volume: 'HCI 97% (515mg)',
  },
];
const fullSpectrumIngredients = [
  {
    name: 'Vitamin A',
    image: vitaminA,
    qus: '',
    content:
      'Vitamin A (Retinol Acetate) is a fat-soluble vitamin essential for vision, immune function, and skin health. It supports cell growth and differentiation, playing a key role in maintaining healthy eyes and skin.',
    volume: '1,500 mcg (167% DV)',
  },
  {
    name: 'Vitamin E',
    image: vitaminE,
    qus: '',
    content:
      'Vitamin E (d-alpha-tocopherol) is a powerful antioxidant that helps protect cells from oxidative damage. It supports immune function and skin health, and is often used in skincare for its moisturizing and protective benefits.',
    volume: '110 mg (733% DV)',
  },
  {
    name: 'Selenium',
    image: Selenium,
    qus: '',
    content:
      'Selenium (Glycinate, ALBION®) is an essential trace mineral that supports antioxidant defenses and thyroid function. It helps protect cells from oxidative stress and contributes to a healthy immune system.',
    volume: '100 mcg (182% DV)',
  },
  {
    name: 'Dunaliella',
    image: dunaliella,
    qus: '',
    content:
      'Dunaliella (Whole Algae, Dunaliella salina) Extract (7.5% Natural Mixed Carotenoids, Betatene®) is a nutrient-rich microalgae known for its high beta-carotene content, a precursor to Vitamin A. It’s valued for its antioxidant properties and potential benefits for skin and eye health.',
    volume: '5 mg',
  },
  {
    name: 'Tocotrienol',
    image: tocotrienol,
    qus: '',
    content:
      'Tocotrienol (From Rice Bran, Oryza sp) is a member of the Vitamin E family with potent antioxidant and anti-inflammatory properties. Tocotrienols may support cardiovascular and brain health more effectively than traditional tocopherols.',
    volume: '12 mg',
  },
  {
    name: 'Aztec Marigold (Tagetes erecta L.)',
    image: aztecMarigold,
    qus: '',
    content:
      'Aztec Marigold (Tagetes erecta L.) Extract (5% Zeaxanthin) is a flower rich in lutein and zeaxanthin, carotenoids known for supporting eye health. It’s commonly used in supplements for its antioxidant properties and protection against blue light damage',
    volume: '60 mg Extract',
  },
  {
    name: 'DMAE Bitartrate',
    image: bitartrate,
    qus: '',
    content:
      'DMAE Bitartrate is a compound that may support cognitive function and skin firmness. It’s often included in supplements and skincare products for its potential anti-aging and neuroprotective effects.',
    volume: '75 mg',
  },
];
const immuneFactorIngredients = [
  {
    name: 'Echinacea Angustifolia',
    image: echinaceaAngustipholia,
    qus: '',
    content:
      'Traditionally used to support immune function and healthy inflammatory responses.',
    volume: '150 mg',
  },
  {
    name: 'Andrographis',
    image: andrographis,
    qus: '',
    content:
      'Known in herbal traditions for bolstering immune defenses, especially during seasonal challenges.',
    volume: '100 mg',
  },
  {
    name: 'Echinacea purpurea',
    image: echinaceaPurpurea,
    qus: '',
    content:
      'A complementary form of Echinacea that helps round out the immune-supporting spectrum.',
    volume: '15 mg',
  },
  {
    name: 'Berberis Aristata',
    image: berberis,
    qus: '',
    content:
      'Berberine is widely studied for its role in supporting gut integrity and immune modulation.',
    volume: '200 mg',
  },
  {
    name: 'Astragalus',
    image: astragalus,
    qus: '',
    content:
      'Revered in traditional wellness practices for energy and immune vigor.',
    volume: '3 mg',
  },
];
const nAcetyleIngredients = [
  {
    name: 'N-Acetyl L-Cysteine',
    image: AcetyleCystine,
    qus: '',
    content:
      'Precursor to glutathione, a key antioxidant helping combat oxidative stress.',
    volume: '600 mg',
  },
  {
    name: 'Selenium',
    image: selenium,
    qus: '',
    content:
      'Selenium as L-Selenomethionine - Essential for producing selenoproteins that bolster antioxidant and immune functions.',
    volume: '25 mcg, 45% DV',
  },
  {
    name: 'Molybdenum',
    image: molybdenum,
    qus: '',
    content:
      'Molybdenum as Sodium Molybdenum Aspartate - Critical for enzyme function, aiding in detoxification pathways.',
    volume: '50 mcg, 111% DV',
  },
];
const redYeastRiceIngredients = [
  {
    name: 'Red Yeast Rice Extract',
    image: redYeastExtract,
    qus: '',
    content:
      'Standardized to 0.4% Monacolin K (500 mcg). Traditionally used for centuries in various wellness practices and studied for its supportive effects on cholesterol maintenance.',
    volume: '500 mcg',
  },
  {
    name: 'CoQ10',
    image: CoQ10,
    qus: '',
    content:
      'Known for its role in cellular energy production and antioxidant protection, particularly in the heart.',
    volume: '75 mg',
  },
];
const vesselProtectionIngredients = [
  {
    name: 'Vitamin B6',
    image: VEPvitaminB6,
    qus: '',
    content:
      'Vitamin B6 (Pyridoxal 5 Phosphate) the active form of B6 supports amino acid metabolism and healthy homocysteine levels.',
    volume: '25 mg (1,471% DV)',
  },
  {
    name: 'Folate',
    image: VEPfolate,
    qus: '',
    content:
      'Folate (L-5-MTHF, Magnofolate® C) supports optimal cardiovascular function and is particularly beneficial for those with MTHFR gene variations.',
    volume: '1,000 mcg DFE (250% DV)',
  },
  {
    name: 'Vitamin B12',
    image: VEPvitaminB12,
    qus: '',
    content:
      'Vitamin B12 (Methylcobalamin) plays an essential role in energy production, red blood cell formation, and homocysteine regulation.',
    volume: '1,005 mcg (41,875% DV)',
  },
];
const vitaminBIngredients = [
  {
    name: 'Vitamin C',
    image: ascorbicAcid,
    qus: '',
    content:
      'Supports immune function, antioxidant defense, and healthy collagen production.',
    volume: '250 mg',
  },
  {
    name: 'Thiamin (Vitamin B1)',
    image: thiamin,
    qus: '',
    content:
      'Helps convert carbohydrates into energy; crucial for healthy nerve function.',
    volume: '49 mg',
  },
  {
    name: 'Riboflavin (Vitamin B2)',
    image: riboflavin,
    qus: '',
    content: 'Aids in energy metabolism and supports skin and eye health.',
    volume: '52 mg',
  },
  {
    name: 'Niacin (Vitamin B3)',
    image: niacin,
    qus: '',
    content:
      'Essential for hundreds of metabolic processes, promotes healthy skin and digestive function.',
    volume: '51 mg',
  },
  {
    name: 'Vitamin B6',
    image: vitaminB6,
    qus: '',
    content: 'Supports mood balance, immune function, and energy metabolism.',
    volume: '50 mg',
  },
  {
    name: 'Folate',
    image: folate,
    qus: '',
    content: 'Important for cell growth, heart health, and prenatal support.',
    volume: '340 mcg DFE',
  },
  {
    name: 'Vitamin B12',
    image: vitaminB12,
    qus: '',
    content:
      'Crucial for red blood cell formation, energy, and healthy nerve function.',
    volume: '100 mcg',
  },
  {
    name: 'Biotin',
    image: biotin,
    qus: '',
    content: 'Helps maintain healthy hair, skin, and nails.',
    volume: '49 mcg',
  },
  {
    name: 'Pantothenic Acid',
    image: pantothenic,
    qus: '',
    content:
      'Vital for hormone production and maintaining a healthy metabolism.',
    volume: '110 mg',
  },
  {
    name: 'Choline',
    image: choline,
    qus: '',
    content: 'Supports brain health and liver function.',
    volume: '23 mg',
  },
  {
    name: 'Inositol',
    image: inositol,
    qus: '',
    content: 'Traditionally used for mood balance and healthy cell signaling.',
    volume: '52 mg',
  },
  {
    name: 'Para-Aminobenzoic Acid',
    image: paraAminobenzoic,
    qus: '',
    content:
      'A lesser-known B-complex nutrient that can support healthy skin and circulation.',
    volume: '52 mg',
  },
];
const vitaminDK2Ingredients = [
  {
    name: 'Vitamin D3',
    image: vitaminD,
    qus: '',
    content:
      'Vitamin D3 (Cholecalciferol) is often cited by experts for its importance in immune function and calcium uptake.',
    volume: '600 mg',
  },
  {
    name: 'Vitamin K2',
    image: vitaminK2,
    qus: '',
    content:
      'Vitamin K2 (Menaquinone-7) is recognized as the superior form of K2 for ensuring calcium goes to your bones instead of your arteries.',
    volume: '2 mg',
  },
];
const vitaminDK5Ingredients = [
  {
    name: 'Vitamin D3',
    image: vitaminD,
    qus: '',
    content:
      'Vitamin D3 (Cholecalciferol) is often cited by experts for its importance in immune function and calcium uptake.',
    volume: '600 mg',
  },
  {
    name: 'Vitamin K2',
    image: vitaminK2,
    qus: '',
    content:
      'Vitamin K2 (Menaquinone-7) is recognized as the superior form of K2 for ensuring calcium goes to your bones instead of your arteries.',
    volume: '2 mg',
  },
];
export const showCaseIngredients = {
  [ProductsCategory.RELIEF_FACTOR]: {
    title2: 'Powered by',
    title3: 'Nature',
    content: reliefFactorIngredients,
  },
  [ProductsCategory.THINK_FACTOR]: {
    title2: 'Powered by',
    title3: 'Nature',
    content: thinkFactorIngredients,
  },
  [ProductsCategory.ZEN_FACTOR]: {
    title2: 'Powered by',
    title3: 'Nature',
    content: zenIngredients,
  },
  [ProductsCategory.GO_FACTOR]: {
    title2: 'Powered by',
    title3: 'Nature',
    content: goFactorIngredients,
  },
  [ProductsCategory.Z_FACTOR]: {
    title2: 'Powered by',
    title3: 'Nature',
    content: zFactorIngredients,
  },
  [ProductsCategory.ANTIOXIDANTS]: {
    title2: 'Powered by',
    title3: 'Nature',
    content: antiOxidantIngredients,
  },
  [ProductsCategory.BERBERINE]: {
    title2: 'Powered by',
    title3: 'Nature',
    content: berberineIngredients,
  },
  [ProductsCategory.FULL_SPECTRUM_E]: {
    title2: 'Powered by',
    title3: 'Nature',
    content: fullSpectrumIngredients,
  },
  [ProductsCategory.IMMUNE_FACTOR]: {
    title2: 'Powered by',
    title3: 'Nature',
    content: immuneFactorIngredients,
  },
  [ProductsCategory.N_ACETYL_CYSTEINE]: {
    title2: 'Powered by',
    title3: 'Nature',
    content: nAcetyleIngredients,
  },
  [ProductsCategory.RED_YEAST_RICE]: {
    title2: 'Powered by',
    title3: 'Nature',
    content: redYeastRiceIngredients,
  },
  [ProductsCategory.VESSEL_PROTECTION]: {
    title2: 'Powered by',
    title3: 'Nature',
    content: vesselProtectionIngredients,
  },
  [ProductsCategory.VITAMIN_B_COMPLEX]: {
    title2: 'Powered by',
    title3: 'Nature',
    content: vitaminBIngredients,
  },
  [ProductsCategory.VITAMIN_D_K2]: {
    title2: 'Powered by',
    title3: 'Nature',
    content: vitaminDK2Ingredients,
  },
  [ProductsCategory.VITAMIN_D_K5]: {
    title2: 'Powered by',
    title3: 'Nature',
    content: vitaminDK5Ingredients,
  },
};
